module.exports = __webpack_public_path__ + "img/Under-Maintenance.bd3d20c0.jpg";